var _g, _path, _path2, _path3, _path4, _g2, _path5, _g3, _path6, _path7, _path8, _path9, _path0, _g4, _path1, _g5, _path10, _path11, _path12, _g6, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgIllustrationLanding = function SvgIllustrationLanding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 423 493"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-landing_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-landing_svg__b)",
    d: "M362.166 329.067 248.95 263.703c-20.996-12.125-54.929-12.125-75.787 0L60.68 329.074c-20.858 12.124-20.752 31.775.244 43.899l113.216 65.365c20.996 12.124 54.929 12.124 75.787 0l112.483-65.365c20.858-12.124 20.746-31.782-.244-43.899z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M362.166 329.067 248.95 263.703c-20.996-12.125-54.929-12.125-75.787 0L60.68 329.074c-20.858 12.124-20.752 31.775.244 43.899l113.216 65.365c20.996 12.124 54.929 12.124 75.787 0l112.483-65.365c20.858-12.124 20.746-31.782-.244-43.899z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-landing_svg__c)",
    d: "M380.993 200.242c0 .101-.008.198-.016.299-.004.09-.012.175-.015.265-.008.101-.02.202-.028.299a4.678 4.678 0 0 1-.027.26c-.011.101-.027.202-.043.303a8.236 8.236 0 0 1-.093.563l-.046.253c-.02.101-.043.202-.066.303-.02.085-.035.167-.059.248l-.081.307c-.024.082-.043.163-.066.245a9.265 9.265 0 0 1-.097.311c-.024.081-.051.159-.074.241-.035.108-.074.213-.113.322l-.081.229c-.059.155-.121.311-.187.47l-.035.086c-.078.186-.159.369-.245.551l-.081.167c-.062.128-.124.257-.187.381-.035.07-.077.14-.112.214a22.04 22.04 0 0 1-.179.334c-.039.066-.078.132-.113.198-.073.124-.143.248-.221.373l-.14.221c-.074.117-.147.233-.225.346a13.876 13.876 0 0 1-.389.563l-.159.222c-.085.116-.175.233-.264.349l-.155.202c-.164.202-.327.408-.502.606-.027.035-.058.066-.089.101-.147.171-.299.338-.451.505-.058.062-.112.124-.17.183-.144.151-.288.303-.435.45l-.152.156c-.198.194-.4.388-.606.582-.078.074-.159.144-.237.218-.097.089-.194.179-.295.268l-.257.221c-.101.086-.202.175-.306.261-.09.073-.179.147-.272.217-.105.086-.21.171-.319.257l-.28.217-.326.249c-.097.073-.198.143-.295.217-.113.082-.221.163-.338.245l-.307.214c-.116.081-.229.159-.35.237l-.318.209c-.12.078-.237.156-.361.233-.109.07-.218.14-.33.206-.125.078-.249.156-.373.229a32.14 32.14 0 0 1-.595.354l-129.176 75.069c-.432.252-.874.493-1.321.73-.117.062-.237.124-.354.187-.4.205-.804.411-1.216.605a40.145 40.145 0 0 1-1.565.711c-.12.055-.245.105-.369.156a40.868 40.868 0 0 1-1.492.598c-.485.186-.975.361-1.472.536-.12.043-.241.082-.365.124-.334.113-.672.222-1.014.327-.322.101-.645.202-.971.295-.276.081-.548.159-.824.237-.33.093-.66.179-.994.264-.28.07-.556.144-.839.21-.338.081-.676.159-1.018.237-.28.062-.559.124-.843.182-.346.074-.695.14-1.045.206-.311.058-.617.121-.928.175l-.424.07a60.58 60.58 0 0 1-1.437.225l-.241.035a55.95 55.95 0 0 1-1.651.21l-.415.047c-.342.038-.684.069-1.03.101a78.133 78.133 0 0 1-2.09.159c-.446.027-.893.05-1.34.066-.252.011-.505.023-.757.031-.389.012-.777.015-1.166.023-.272 0-.543.012-.815.012-.416 0-.832-.008-1.247-.012-.245 0-.49 0-.734-.011a62.371 62.371 0 0 1-1.143-.047c-.264-.012-.532-.019-.796-.031-.412-.023-.819-.055-1.231-.086a41.03 41.03 0 0 1-.699-.05 93.923 93.923 0 0 1-1.5-.144c-.14-.015-.28-.027-.419-.043a60.6 60.6 0 0 1-1.908-.24c-.105-.016-.206-.035-.307-.047-.54-.078-1.08-.163-1.619-.256-.226-.039-.447-.086-.672-.125a60.908 60.908 0 0 1-1.232-.233c-.214-.043-.427-.093-.641-.14-.45-.097-.897-.198-1.34-.303-.249-.058-.493-.124-.738-.186-.404-.105-.808-.21-1.208-.319-.342-.097-.688-.19-1.026-.291-.128-.039-.256-.074-.384-.113a45.123 45.123 0 0 1-1.523-.489c-.097-.031-.19-.066-.284-.101a58.412 58.412 0 0 1-1.654-.606 32.01 32.01 0 0 1-.968-.389 35.06 35.06 0 0 1-.66-.271 47.023 47.023 0 0 1-.928-.416l-.606-.276a38.076 38.076 0 0 1-.991-.493c-.163-.082-.33-.163-.493-.249a41.267 41.267 0 0 1-1.438-.788L53.832 216.01c-7.862-4.537-11.785-10.492-11.77-16.444L42 221.735c-.016 5.948 3.908 11.907 11.77 16.444l130.024 75.069c.47.272.948.532 1.437.788.163.086.33.163.493.249.327.167.657.334.991.493.198.093.404.187.606.276.307.14.614.28.924.416.218.093.439.182.661.275.213.086.419.179.633.265.109.042.221.085.33.124l.42.159c.408.155.819.303 1.239.447.097.035.19.07.287.101a45.123 45.123 0 0 0 1.908.602c.217.066.435.132.656.194.121.035.245.062.365.097.4.113.804.218 1.212.319l.738.186c.443.105.894.206 1.34.303.167.035.335.078.502.113.046.008.093.015.136.027.407.086.823.159 1.235.237.221.043.443.086.668.124.536.094 1.076.175 1.62.257l.291.046h.016c.633.09 1.266.171 1.903.241.148.016.295.027.443.043.493.05.983.101 1.48.144h.035c.217.019.435.027.653.042.411.031.827.063 1.243.086.264.015.528.023.792.031.381.015.765.035 1.146.047h.093c.214.003.424 0 .637.007.416.008.835.016 1.251.012.272 0 .54-.008.812-.012.388-.004.781-.011 1.169-.023.07 0 .144 0 .214-.004l.54-.027c.447-.02.897-.039 1.344-.066a79.965 79.965 0 0 0 2.09-.159c.147-.016.299-.024.45-.039.195-.02.389-.043.579-.062l.416-.047a56.82 56.82 0 0 0 1.895-.245 56.612 56.612 0 0 0 1.861-.299l.338-.058c.198-.035.396-.078.594-.117a42.568 42.568 0 0 0 1.888-.392c.342-.078.68-.151 1.018-.233l.839-.21c.334-.085.664-.175.991-.264.276-.078.551-.155.827-.237.326-.097.649-.194.971-.295l.424-.128.59-.198c.121-.039.241-.082.361-.121.498-.171.991-.349 1.477-.536l.268-.105c.411-.159.819-.326 1.223-.493.121-.051.245-.101.365-.156.474-.202.94-.411 1.403-.629a57.682 57.682 0 0 0 1.383-.684l.353-.186c.447-.237.89-.478 1.321-.73l129.176-75.069c.164-.097.327-.19.486-.288.039-.023.074-.046.109-.066.124-.073.245-.151.369-.229.112-.07.225-.14.334-.21.12-.077.241-.155.357-.233.109-.07.214-.139.319-.209.116-.078.233-.16.346-.237.104-.07.205-.144.306-.214l.338-.245c.101-.074.198-.143.296-.217l.326-.249c.093-.074.19-.144.283-.217.109-.086.214-.171.319-.257.089-.074.179-.144.268-.217.105-.086.206-.175.307-.261.085-.073.171-.143.256-.217.101-.089.202-.179.303-.272.07-.062.144-.124.21-.19a28.603 28.603 0 0 0 .633-.606c.051-.051.101-.105.156-.156.147-.147.295-.299.435-.45.058-.063.116-.121.171-.183.155-.167.303-.334.45-.505l.09-.101a44.565 44.565 0 0 0 .543-.656c.039-.051.074-.101.113-.148.089-.117.179-.233.264-.35.055-.073.109-.147.159-.221.082-.113.164-.225.241-.342a22.868 22.868 0 0 0 .377-.575c.047-.074.093-.144.136-.217a8.77 8.77 0 0 0 .221-.377c.032-.051.063-.101.09-.152l.023-.042c.062-.113.121-.222.179-.334.039-.07.078-.14.112-.214.067-.128.129-.256.191-.385l.081-.163a13.734 13.734 0 0 0 .272-.625c.066-.159.132-.323.195-.486 0-.008.003-.011.007-.019.027-.07.051-.14.074-.21.039-.109.078-.214.113-.322.027-.082.05-.16.074-.241.031-.105.066-.206.097-.311.023-.082.046-.167.066-.249l.081-.303c.02-.085.039-.171.059-.252.023-.101.046-.202.066-.303 0-.02.007-.035.011-.054l.035-.202c.02-.101.039-.202.055-.307.015-.086.027-.171.038-.257.016-.101.028-.202.043-.303a4.58 4.58 0 0 0 .027-.26c.012-.101.02-.202.028-.299.007-.089.011-.175.015-.264.004-.101.012-.198.016-.299 0-.031.004-.066.004-.097 0-.117.003-.234.003-.35l.063-22.165c0 .147-.004.299-.012.446z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-landing_svg__d)",
    d: "M369.234 183.348 239.211 108.28c-15.62-9.02-40.866-9.02-56.385 0L53.65 183.348c-15.523 9.02-15.437 23.642.182 32.662l130.024 75.069c15.62 9.019 40.865 9.019 56.384 0l129.177-75.069c15.518-9.02 15.437-23.642-.183-32.662"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-landing_svg__e)",
    d: "m302.16 187.575-74.724-43.142c-8.977-5.182-23.486-5.182-32.401 0l-74.233 43.142c-8.919 5.182-8.873 13.588.105 18.77l74.723 43.142c8.977 5.182 23.486 5.182 32.405 0l74.233-43.142c8.919-5.182 8.873-13.584-.105-18.77z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "illustration-landing_svg__f",
    width: 195,
    height: 114,
    x: 114,
    y: 140,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m302.16 187.575-74.724-43.142c-8.977-5.182-23.486-5.182-32.401 0l-74.233 43.142c-8.919 5.182-8.873 13.588.105 18.77l74.723 43.142c8.977 5.182 23.486 5.182 32.405 0l74.233-43.142c8.919-5.182 8.873-13.584-.105-18.77z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#illustration-landing_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0E2761",
    d: "m285.755 201.944-61.197-35.33c-7.353-4.246-19.232-4.246-26.535 0l-60.797 35.33c-7.307 4.246-7.268 11.129.085 15.371l61.197 35.33c7.354 4.246 19.233 4.246 26.54 0l60.797-35.33c7.303-4.246 7.264-11.125-.086-15.371z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "illustration-landing_svg__g",
    width: 24,
    height: 8,
    x: 193,
    y: 195,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m216.15 202.766-20.552-5.907a6.09 6.09 0 0 1-2.132-1.157l20.522 5.907c.634.528 1.37.922 2.162 1.157"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#illustration-landing_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#436628",
    d: "m216.149 202.766-20.551-5.907a6.09 6.09 0 0 1-2.132-1.157l20.522 5.907c.634.528 1.37.922 2.161 1.157"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#5A8936",
    d: "m216.665 158.444-20.552-5.937 49.172-89.697 20.552 5.937z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#406227",
    d: "m215.508 128.086-20.521-5.907-21.1-16.898 20.552 5.907z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#598936",
    d: "m194.439 111.185-20.552-5.906 26.824-50.39 20.552 5.906z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#406227",
    d: "m221.263 60.797-20.552-5.907-12.94-10.474 20.552 5.907z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "illustration-landing_svg__h",
    width: 23,
    height: 7,
    x: 186,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m188.258.238 20.552 5.907a5.328 5.328 0 0 0-2.192-.183L186.066.025a5.845 5.845 0 0 1 2.192.213"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#illustration-landing_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#527D31",
    d: "M206.618 5.962 186.066.024h.852l20.552 5.938a3.922 3.922 0 0 0-.852 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F7A30",
    d: "M207.47 5.931 186.919-.006c.329.019.655.07.974.152l20.552 5.907a5.701 5.701 0 0 0-.975 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D762E",
    d: "M208.444 6.055 187.893.148h.365l20.552 5.907z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "illustration-landing_svg__i",
    width: 29,
    height: 12,
    x: 178,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m199.219 11.619-20.552-5.907A10.084 10.084 0 0 1 186.066.02l20.552 5.937a10.017 10.017 0 0 0-7.399 5.663"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#illustration-landing_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#527D31",
    d: "M199.219 11.617 178.667 5.71l.427-.76 20.551 5.936a9.222 9.222 0 0 0-.426.731"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#548133",
    d: "M199.645 10.888 179.094 4.95c.365-.548.761-1.065 1.157-1.553l20.521 5.907a16.269 16.269 0 0 0-1.127 1.583"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#578534",
    d: "m200.772 9.304-20.521-5.907a10.013 10.013 0 0 1 3.988-3.044l20.522 5.937a10.349 10.349 0 0 0-3.989 3.044"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#548133",
    d: "M204.76 6.383 184.239.446a8.616 8.616 0 0 1 1.522-.396l20.552 5.937a5.822 5.822 0 0 0-1.553.396"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#527D31",
    d: "M206.344 5.987 185.792.05h.304l20.552 5.937z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#406227",
    d: "m213.988 201.616-20.521-5.907-75.661-61.868 20.551 5.937z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#5A8936",
    d: "m137.198 124.588-20.552-5.937L178.667 5.692l20.552 5.938z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "illustration-landing_svg__j",
    width: 25,
    height: 22,
    x: 114,
    y: 118,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m138.355 139.774-20.552-6.089c-3.593-3.045-4.141-9.804-1.157-15.224l20.552 6.089c-2.984 5.42-2.436 12.24 1.157 15.224"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#illustration-landing_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#436628",
    d: "m138.355 139.777-20.552-6.089a9.897 9.897 0 0 1-3.044-7.582l20.551 5.907a9.816 9.816 0 0 0 3.045 7.612"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#456A2A",
    d: "m135.28 132.168-20.552-5.907c-.03-.578-.03-1.158 0-1.736l20.522 5.938a10.55 10.55 0 0 0 0 1.705"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#486E2B",
    d: "m135.341 130.465-20.521-5.937c.043-.481.114-.959.213-1.431l20.521 5.937c0 .457-.152.944-.213 1.431"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A722D",
    d: "m135.554 129.028-20.552-5.937c0-.426.183-.852.305-1.279l20.552 5.907c0 .427-.244.853-.335 1.309"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D762E",
    d: "m135.889 127.725-20.552-5.906c0-.427.274-.853.426-1.249l20.552 5.907a9.973 9.973 0 0 0-.426 1.248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F7A30",
    d: "m136.315 126.475-20.552-5.906c.152-.43.335-.847.548-1.249l20.552 5.907a11.16 11.16 0 0 0-.548 1.248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#527D31",
    d: "m136.863 125.226-20.552-5.907a4.76 4.76 0 0 1 .335-.67l20.552 6.09c-.123.207-.235.42-.335.639"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#80C44D",
    d: "M206.617 5.964a5.666 5.666 0 0 1 4.263 1.28l41.743 33.674c3.593 3.044 4.171 9.651 1.279 15.04l-38.424 72.13-21.07-16.898 26.824-50.39-12.94-10.474-38.394 70.028 46.737 38.211 49.172-89.697 14.34 11.996c3.563 3.045 4.05 9.774 1.127 15.224l-55.597 101.389a10.13 10.13 0 0 1-7.398 5.693 5.905 5.905 0 0 1-4.324-1.37l-75.63-61.838c-3.593-3.045-4.141-9.804-1.157-15.224l62.02-112.958a10.022 10.022 0 0 1 7.429-5.815"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-landing_svg__b",
    x1: 211.544,
    x2: 209.371,
    y1: 254.609,
    y2: 510.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C5CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C5CCB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-landing_svg__c",
    x1: 260.332,
    x2: 280.554,
    y1: 182.775,
    y2: 319.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-landing_svg__d",
    x1: 211.533,
    x2: 211.533,
    y1: 101.515,
    y2: 297.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#9FBCFF",
    stopOpacity: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-landing_svg__e",
    x1: 239.594,
    x2: 269.42,
    y1: 124.816,
    y2: 248.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-landing_svg__a",
    width: 423.198,
    height: 284.603,
    x: 0.198,
    y: 208.198,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5611_116230",
    stdDeviation: 22.401
  })))));
};
var Memo = /*#__PURE__*/memo(SvgIllustrationLanding);
export default Memo;